import { paths } from '@common/types';

export type ChartEntryDetails = {
  label: string;
  value: number;
  percentage: string;
};

export type ChartEntry = {
  label: string;
  value: number;
  details?: ChartEntryDetails[];
};

//Shape needs a special type
export type BarChartEntry = {
  label: string;
  [key: string]: string | number;
};

export type ChartsTimeInterval =
  paths[`/reporting/users/own-metrics`]['get']['parameters']['query']['interval'];

export type ChartsRoles =
  paths[`/reporting/patients/metrics/care-management`]['get']['parameters']['query']['roles'];

export type NonAdminDashboardFilters = {
  interval: ChartsTimeInterval;
  to_date: string;
  from_date: string;
};

export type AdminDashboardFilters = {
  roles: ChartsRoles;
  users: string[];
  teams: string[];
  interval: ChartsTimeInterval;
  to_date: string;
  from_date: string;
  supervisor_ids: string[];
  record_ids: string[];
};

export const chartTimeIntervalOptions: {
  value: ChartsTimeInterval;
  label: string;
}[] = [
  // { value: 'all_time', label: 'All time' },
  { value: 'custom', label: 'Custom' },
  { value: 'last_year', label: 'Last year' },
  { value: 'this_year', label: 'This year' },
  { value: 'last_quarter', label: 'Last quarter' },
  { value: 'this_quarter', label: 'This quarter' },
  { value: 'last_month', label: 'Last month' },
  { value: 'this_month', label: 'This month' },
  {
    value: 'current_and_previous_month',
    label: 'Current and previous month',
  },
  { value: 'last_week', label: 'Last week' },
  { value: 'this_week', label: 'This week' },
  { value: 'yesterday', label: 'Yesterday' },
  { value: 'today', label: 'Today' },
  { value: 'last_7_days', label: 'Last 7 days' },
  { value: 'last_30_days', label: 'Last 30 days' },
  { value: 'last_60_days', label: 'Last 60 days' },
  { value: 'last_90_days', label: 'Last 90 days' },
  { value: 'last_120_days', label: 'Last 120 days' },
];
